import { FC, useState } from 'react';
import { HomeContextProvider } from '../../context/home-context';
import { useGetTrendingItems } from '../../services/trending-item/trending-item.service';
import CuisineBadgesContainer from './CuisineBadgesContainer';
import RestaurantsNearby from './RestaurantsNearby';
import SearchBar from './SearchBar';
import TrendingToday from './TrendingToday';

const Home: FC = () => {
  const [hasTrendingItems, setHasTrendingItems] = useState(false);

  return (
    <HomeContextProvider>
      <SearchBar />
      <TrendingToday setHasTrendingItems={setHasTrendingItems} />
      <CuisineBadgesContainer />
      <RestaurantsNearby hasTrendingItems={hasTrendingItems} />
    </HomeContextProvider>
  );
};

export default Home;
